var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#A2A5B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.632 7.00003C10.632 7.35736 10.5493 7.6827 10.384 7.97603C10.2187 8.26403 9.97333 8.49336 9.648 8.66403C9.328 8.8347 8.93867 8.92003 8.48 8.92003H7.776V10.72H6V5.05603H8.48C9.17333 5.05603 9.704 5.23203 10.072 5.58403C10.4453 5.93603 10.632 6.40803 10.632 7.00003ZM8.28 7.52003C8.648 7.52003 8.832 7.3467 8.832 7.00003C8.832 6.65336 8.648 6.48003 8.28 6.48003H7.776V7.52003H8.28Z",
    fill: "#A2A5B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSquare);
export default __webpack_public_path__ + "static/media/p-square.547cb2fe6c6660aa1434b626547fa8c4.svg";
export { ForwardRef as ReactComponent };